export default "__VITE_ASSET__aaca244d__"